import React, { Fragment, useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { DataGrid } from '@mui/x-data-grid';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button.js';
import ModalFull from 'components/Tvendo/Common/ModalFull';

import { wsFindBy, wsCreate } from 'services/WService';

const columns = [
  { headerName: 'Código', field: 'code', width: 140 },
  { headerName: 'Nombre Cliente', field: 'description', flex: 1 },
];

export default function Modal({ open, setOpen, showNotify, reload }) {
  const [providers, setProviders] = useState([]);
  const [bLines, setBLines] = useState([]);

  const [bLineSelects, setBLinesSelects] = useState([]);
  const [provider, setProvider] = useState({});

  async function listProviders() {
    const response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }

  async function listBLines() {
    const response = await wsFindBy('base/business-line', {
      base_business_partner_id: provider.id,
      promotion_list: 'Y',
    });
    if (response.success) setBLines(response.data);
  }

  async function saveData() {
    const formatData = { provider_id: provider.id, businessLines: bLineSelects };
    const response = await wsCreate('prom/provider-business-line', formatData);
    if (response.success) {
      showNotify(response.message);
      reload();
      setOpen(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listProviders();
    return () => {
      setProviders([]);
    };
  }, []);

  useEffect(() => {
    if (provider.id) listBLines();
  }, [provider.id]);

  return (
    <ModalFull title="Asignar giros de negocio a proveedor" open={open} setOpen={setOpen}>
      <GridContainer>
        <GridItem xs={12} lg={3}>
          <Autocomplete
            disableClearable
            options={providers}
            getOptionLabel={(option) => option.CardName}
            renderInput={(params) => (
              <TextField {...params} label="Seleccione proveedor" margin="normal" required />
            )}
            onChange={(e, item) => setProvider(item)}
          />
        </GridItem>
      </GridContainer>

      {provider.id && (
        <Fragment>
          <Card>
            <CardBody>
              <div style={{ height: 460, width: '100%' }}>
                <DataGrid
                  density="compact"
                  columns={columns}
                  rows={bLines}
                  size="small"
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  selectionModel={bLineSelects}
                  onSelectionModelChange={(model) => setBLinesSelects(model)}
                  checkboxSelection
                  opt
                />
              </div>
            </CardBody>
          </Card>
          <Button onClick={saveData} color="success" style={{ float: 'right' }}>
            Guardar
          </Button>
        </Fragment>
      )}
    </ModalFull>
  );
}
